function getTimeFromIndex(index) {
    if(index === 24)
        return '12 AM'
    return `${index % 12 === 0 ? 12 : (index % 12) } ${index > 11 ? 'PM' : 'AM'}`
}
/**
 * Returns no. of hours and minutes passed for time in milliseconds
 * @param {Number} inputTime 
 */
function getHrMnForDay(inputTime) {
    const inputDate = new Date(inputTime)
    const noOfHours = Math.floor(inputDate / (1000 * 3600)),
        noOfMinutes = inputDate.getUTCMinutes()
    return inputTime !== 0 ? noOfHours + ':' + String(noOfMinutes).padStart(2, '0') : '00:00'
}

/**
 * Get an array of dates from current to 
 * 30 days before
 *
 * @returns
 */
function getLast30Days() {
    return getLastNDays(30)
}

/**
 * Returns an array from current date to `n`
 * days before that
 *
 * @param {Number} n
 * @returns {[Date]}
 */
function getLastNDays(n) {
    if(isNaN(n))
        throw new TypeError('Expected an integer as input')

    // Create an empty array of length `n` and map
    // through getting dates for each
    return [...new Array(n).keys()].map((key) => {
        let date = new Date()
        date.setHours(0, 0, 0, 0)
        date.setDate(date.getDate() - key)
        return date
    })
}

export {
    getTimeFromIndex,
    getHrMnForDay,
    getLast30Days,
    getLastNDays
}
